import React from "react";
import styled from "styled-components";
import Paragraph from "../atoms/Paragraph";
import Button from "../atoms/Button";
import { withModal } from "../../contexts/ModalContext";
import { useDispatch } from "react-redux";
import * as action from "../../store/actions";
import { useTranslation } from "react-i18next";

const StyledParagraph = styled(Paragraph)`
  margin-bottom: 20px;
`;

const TokenExpiredModal = ({ onRequestClose }) => {
  const { t } = useTranslation(["common", "dossier"]);

  const dispatch = useDispatch();

  const close = () => {
    dispatch(action.authDossierLogout(false));
    onRequestClose();
  };

  return (
    <>
      <StyledParagraph>{t("dossier:expired_modal.logged_out")}</StyledParagraph>
      <Button primary wide onClick={close}>
        {t("generic.close")}
      </Button>
    </>
  );
};

export default withModal(TokenExpiredModal);
